import React, { useState } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { bulkDeleteCompanies } from "../../../middleware/backend_hepler";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const BulkCompanyDelete = () => {
  const [loading, setLoading] = useState(false);
  const [fileName, setFileName] = useState("");
  const navigate = useNavigate();

  const methods = useForm();

  const {
    handleSubmit,
    register,
    formState: { isSubmitting },
  } = methods;

const onSubmit = async (data) => {
  if (!data.delete_csv_file?.[0]) {
    toast.error("Please upload a CSV file.");
    return;
  }

  const formData = new FormData();
  formData.append("file", data.delete_csv_file[0]);

  try {
    setLoading(true);
    const response = await bulkDeleteCompanies(formData); 

    setLoading(false);

    toast.success("Bulk delete successful!");
    setTimeout(() => navigate("/companylist"), 2000);
  } catch (error) {
    setLoading(false);
    console.error("Error in bulk delete:", error);
    toast.error("Failed to delete. Please try again.");
  }
};


  const handleFileChange = (e) => {
    if (e.target.files.length > 0) {
      setFileName(e.target.files[0].name);
    } else {
      setFileName("");
    }
  };

  return (
    <div className="edit-all-loan-container">
      <div className="edit-back-icon">
        <div
          className="edit-back-text"
          onClick={() => navigate("/companylist")}
        >
          &lt; Go Back
        </div>
      </div>

      <h2>Company</h2>

      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="form-row">
            <div className="sections personal-details-sections mt-4">
              <label htmlFor="delete_csv_file" className="document-label">
                Bulk Company Delete
              </label>
              <input
                type="file"
                id="delete_csv_file"
                accept=".csv"
                {...register("delete_csv_file")}
                onChange={handleFileChange}
                className="form-control-file"
              />
              <span className="file-upload-message">
                Please upload a CSV file with a maximum of 5000 rows.
              </span>
            </div>
            <div className="button-container text-center">
              <Button
                variant="danger"
                type="submit"
                className="custom-submit-button custom-delete-button"
                disabled={isSubmitting || loading}
              >
                {loading ? "Deleting..." : "Delete"}
              </Button>
            </div>
          </div>
        </form>
      </FormProvider>
      <ToastContainer />
    </div>
  );
};

export default BulkCompanyDelete;
